<template>
  <g>
    <path
      d="M13.7542 17.0088H8.94774C8.42219 17.0088 7.99219 16.5788 7.99219 16.0532C7.99219 15.5277 8.42219 15.0977 8.94774 15.0977H13.7542C14.2797 15.0977 14.7097 15.5277 14.7097 16.0532C14.7097 16.5883 14.2797 17.0088 13.7542 17.0088Z"
      :fill="iconColor"
    />
    <path
      d="M11.3564 19.4168C10.8309 19.4168 10.4009 18.9868 10.4009 18.4612V13.6548C10.4009 13.1292 10.8309 12.6992 11.3564 12.6992C11.882 12.6992 12.312 13.1292 12.312 13.6548V18.4612C12.312 18.9868 11.882 19.4168 11.3564 19.4168Z"
      :fill="iconColor"
    />
    <path
      d="M20.7482 22.4969H10.7149C7.16023 22.4969 4.26489 19.6016 4.26489 16.0469C4.26489 12.4923 7.16023 9.59692 10.7149 9.59692H20.7482C24.3029 9.59692 27.1982 12.4923 27.1982 16.0469C27.1982 19.6016 24.3029 22.4969 20.7482 22.4969ZM10.7149 11.508C8.21134 11.508 6.176 13.5434 6.176 16.0469C6.176 18.5505 8.21134 20.5858 10.7149 20.5858H20.7482C23.2518 20.5858 25.2871 18.5505 25.2871 16.0469C25.2871 13.5434 23.2518 11.508 20.7482 11.508H10.7149Z"
      :fill="iconColor"
    />
    <path
      d="M20.5109 12.9045C19.8897 12.9045 19.3833 13.411 19.3833 14.0321C19.3833 14.6532 19.8897 15.1597 20.5109 15.1597C21.132 15.1597 21.6384 14.6532 21.6384 14.0321C21.6384 13.411 21.132 12.9045 20.5109 12.9045Z"
      :fill="iconColor"
    />
    <path
      d="M20.5109 16.967C19.8897 16.967 19.3833 17.4735 19.3833 18.0946C19.3833 18.7157 19.8897 19.2222 20.5109 19.2222C21.132 19.2222 21.6384 18.7157 21.6384 18.0946C21.6384 17.4735 21.132 16.967 20.5109 16.967Z"
      :fill="iconColor"
    />
    <path
      d="M22.5463 14.938C21.9251 14.938 21.4187 15.4444 21.4187 16.0655C21.4187 16.6867 21.9251 17.1931 22.5463 17.1931C23.1674 17.1931 23.6738 16.6867 23.6738 16.0655C23.6643 15.4349 23.1674 14.938 22.5463 14.938Z"
      :fill="iconColor"
    />
    <path
      d="M18.486 14.938C17.8648 14.938 17.3584 15.4444 17.3584 16.0655C17.3584 16.6867 17.8648 17.1931 18.486 17.1931C19.1071 17.1931 19.6135 16.6867 19.6135 16.0655C19.604 15.4349 19.1071 14.938 18.486 14.938Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
